// extracted by mini-css-extract-plugin
export default {"inputSection":"tAb6B0","suggestions":"tXBims","suggestionsHeader":"OkFVsZ","suggestionsOptions":"hrBdph","acceptTermsSection":"hAggL9","acceptTermsTitle":"_kdvih"};